import { t } from '@/utils/i18n'

export const NodeTypes = {
    START: { type: 'start', label: t('workFlow.nodeConfig.start') },
    END: { type: 'end', label: t('workFlow.nodeConfig.end') },
    APP: { type: 'app', label: t('workFlow.nodeConfig.app'), nodeType: 'basics', desc: t('workFlow.nodeConfig.appDesc') },
    LLM: { type: 'llm', label: t('workFlow.nodeConfig.llm'), nodeType: 'basics', desc: t('workFlow.nodeConfig.llmDesc') },
    KNOWLEDGE_BASE: { type: 'knowledge_base', label: t('workFlow.nodeConfig.knowledgeBase'), nodeType: 'basics', desc: t('workFlow.nodeConfig.knowledgeBaseDesc') },
    DATABASE: { type: 'database', label: t('workFlow.nodeConfig.database'), nodeType: 'basics', desc: t('workFlow.nodeConfig.databaseDesc') },
    PLUGIN: { type: 'plugin', label: t('workFlow.nodeConfig.plugin'), nodeType: 'basics', desc: t('workFlow.nodeConfig.pluginDesc') },
    CODE: { type: 'code_block', label: t('workFlow.nodeConfig.code'), nodeType: 'basics', desc: t('workFlow.nodeConfig.codeDesc') },
    INTENT_BRANCH: { type: 'intent_branch', label: t('workFlow.nodeConfig.intentBranch'), nodeType: 'branch', desc: t('workFlow.nodeConfig.intentBranchDesc') },
    LOGIC_BRANCH: { type: 'logic_branch', label: t('workFlow.nodeConfig.logicBranch'), nodeType: 'branch', desc: t('workFlow.nodeConfig.logicBranchDesc') },
    FIXED_REPLY: { type: 'fixed_reply', label: t('workFlow.nodeConfig.fixedReply'), nodeType: 'individuality', desc: t('workFlow.nodeConfig.fixedReplyDesc') },
    CHANNEL_SEND: { type: 'channel_send', label: t('workFlow.nodeConfig.channelSend'), nodeType: 'individuality', desc: t('workFlow.nodeConfig.channelSendDesc') },
    MANUAL: { type: 'manual', label: t('workFlow.nodeConfig.manual'), nodeType: 'individuality', desc: t('workFlow.nodeConfig.manualDesc') },
};

export function convertObjectToArrayDirectly(obj: any) {
    const result = Object.values(obj); // 直接获取对象的所有值
    return result;
}

export const slideList = [
    {
        type: 'start',
        label: t('workFlow.nodeConfig.start'),
    },
    {
        type: 'end',
        label: t('workFlow.nodeConfig.end'),
    },
    {
        type: 'intent_branch',
        label: t('workFlow.nodeConfig.intentBranch'),
    },
    {
        type: 'logic_branch',
        label: t('workFlow.nodeConfig.logicBranch'),
    },
    {
        type: 'fixed_reply',
        label: t('workFlow.nodeConfig.fixedReply'),
    },
    {
        type: 'llm',
        label: t('workFlow.nodeConfig.llm'),
    },
    {
        type: 'knowledge_base',
        label: t('workFlow.nodeConfig.knowledgeBase'),
    },
    {
        type: 'app',
        label: t('workFlow.nodeConfig.app'),
    },
    {
        type: 'plugin',
        label: t('workFlow.nodeConfig.plugin'),
    },
    {
        type: 'code_block',
        label: t('workFlow.nodeConfig.code'),
    },
    {
        type: 'database',
        label: t('workFlow.nodeConfig.database'),
    },
    {
        type: 'manual',
        label: t('workFlow.nodeConfig.manual'),
    },
    {
        type: 'channel_send',
        label: t('workFlow.nodeConfig.channelSend'),
    },
];